class ProductHighlight extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.wrapper = this.querySelector('[data-highlighted-product-variants]');
    this.variantInputs = this.wrapper.querySelectorAll('input');
    this.image = this.querySelector('[data-highlighted-product-image]');
    this.productInfo = this.querySelector('[data-highlighted-product-info]');
    this.variantJson = JSON.parse(this.querySelector('[type="application/json"]').textContent);

    this.listeners = {
      onImageLoad: this.onImageLoad.bind(this),
      change: event => this.onVariantChange(event),
    };

    this.variantInputs.forEach(variant => variant.addEventListener('change', this.listeners.change));
    window.addEventListener('window:resize', this.listeners.onImageLoad);
    window.addEventListener('load', this.listeners.onImageLoad);
  }

  disconnectedCallback() {
    this.variantInputs.forEach(variant => variant.removeEventListener('change', this.listeners.change));
    this.image.removeEventListener('load', this.listeners.onImageLoad);
    window.removeEventListener('window:resize', this.listeners.onImageLoad);
  }

  onImageLoad() {
    const imageHeight = this.image.getBoundingClientRect().height;
    this.closest('section').style.setProperty('--highlight-image-height', `${imageHeight / 2}px`);
  }

  onVariantChange(event) {
    const variant = this.variantJson.items.find(variant => variant?.id === event.target.value);

    if (variant) {
      const price = Shopify.formatMoney(variant.price).replace(',00', ',-');
      const compareAtPrice = Shopify.formatMoney(variant.compare_at_price).replace(',00', ',-');
      const discount = Shopify.formatMoney(variant.compare_at_price - variant.price).replace(',00', ',-');
      const isOnSale = variant.compare_at_price > variant.price && variant.available;
      const priceHtml = `
        ${variant.compare_at_price > variant.price && variant.available ? `
          <dl class="price__sale flex flex-wrap gap-x-2">
            <dt class="sr-only">
              ${this.variantJson.sale_price_str}
            </dt>
            <dd class="price__item price__item--sale text-primary font-semibold">
              ${price}
            </dd>
            <dt class="sr-only ">
              ${this.variantJson.regular_price_str}
            </dt>
            <dd class="price__item price__item--regular">
              <s class="price__item price__item--compare text-secondary-300 text-xs md:text-sm">
                ${compareAtPrice}
              </s>
            </dd>
          </dl>
          ${isOnSale ? `
            <span class="text-secondary-300 text-xs md:text-sm">
              ${this.variantJson.discount_str.replace('[[discount]]', discount)}
            </span>
          ` : ''}
        ` : `
          <dl class="price__regular text-primary label-sm md:label-md">
            <dt class="sr-only ">
              ${this.variantJson.regular_price_str}
            </dt>
            <dd class="price__item price__item--regular">
              ${price}
            </dd>
          </dl>
        `}
      `;

      this.image.classList.add('opacity-0');
      this.image.addEventListener('transitionend', () => {
        this.image.querySelector('a').href = variant.url;
        this.image.querySelector('a').title = variant.title;
        this.image.querySelector('img').src = variant.featured_image;
        this.image.querySelector('img').alt = variant.title;
        this.image.querySelector('img').srcset = '';
        this.image.classList.remove('opacity-0');
        this.listeners.onImageLoad;

        this.querySelector('.product-card__description').innerHTML = variant.description;
        this.querySelector('.heading').innerHTML = variant.title;

        // Create the subtitle if it doesn't exist
        if (variant.subtitle != '') {
          if (this.querySelector('.subtitle')) {
            this.querySelector('.subtitle').innerHTML = variant.subtitle;
          }
          else {
            this.querySelector('.subtitle').innerHTML = `<p class="heading-subtitle text-secondary-300 subtitle mb-2.5 text-sm">${variant.subtitle}</p>`;
          }
        }
        if (variant.usps != null) {
          this.querySelector('.product-card__usps').innerHTML = `<div class="product-usps flex flex-wrap gap-2 text-xs font-medium md:text-sm">${variant.usps.map(usp => `<div class="product-usp bg-bg rounded-md border p-2 text-black">${usp}</div>`).join('')}</div>`;
        }
        else {
          this.querySelector('.product-card__usps').innerHTML = '';
        }

        if (this.querySelector('.price')) {
          this.querySelector('.price').innerHTML = priceHtml;
          if (isOnSale) {
            this.querySelector('.price').classList.add('price--on-sale');
          }
          else if (!variant.available) {
            this.querySelector('.price').classList.add('price--sold-out');
          }
        }

        if (this.querySelector('product-form-component')) {
          const submitButton = this.querySelector('.product-form__buttons').querySelector('button[type="submit"]');
          const submitButtonText = submitButton.querySelector('[data-add-to-cart-button-text]');
          if (variant.available) {
            submitButtonText.textContent = submitButton.dataset.addToCartAvailableText;
            submitButton.disabled = false;
          }
          else {
            submitButtonText.textContent = submitButton.dataset.addToCartSoldOutText;
            submitButton.disabled = true;
          }

          this.querySelector('product-form-component').querySelector('input[name="id"]').value = variant.variant_id;
        }
      });

      this.querySelector('.product-card__link').href = variant.url;
      this.querySelector('.product-card__link').title = variant.title;

    }
  }
}
if (!customElements.get('product-highlight')) {
  customElements.define('product-highlight', ProductHighlight);
}